import { render, staticRenderFns } from "./publictemplate.vue?vue&type=template&id=c2f3610a&scoped=true"
import script from "./publictemplate.vue?vue&type=script&lang=js"
export * from "./publictemplate.vue?vue&type=script&lang=js"
import style0 from "./publictemplate.vue?vue&type=style&index=0&id=c2f3610a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f3610a",
  null
  
)

export default component.exports